import {
    Dispatch,
    FC,
    SetStateAction,
    useCallback,
    useMemo,
    useRef,
    useState,
} from "react";
import { DropDownItems } from "@/models/common/enums";
import { BREACKPOINT_TABLET } from "@/utils/constants";
import { useWindowSizes } from "@/hooks/useWindowSizes";
import { useOnClickOutside } from "@/hooks/useOnClickOutiside";
import styles from "../../../styles/navbar/NavBar.module.scss";
import DropdownMenu from "./DropdownMenu";
import NavBar from "./NavBar";
import NavBarM from "./NavBarM/NavBarM";
import useNavBarData from "../../../utils/queries/hooks/useNavBarData";
import useHomeData from "../../../utils/queries/hooks/useHomeData";

type NavBarLayoutProps = {
    setShowModal: Dispatch<SetStateAction<boolean>>;
    setShowSearchModal: Dispatch<SetStateAction<boolean>>;
    bannerLabel: string;
};

const NavBarLayout: FC<NavBarLayoutProps> = ({
    setShowModal,
    setShowSearchModal,
    bannerLabel,
}) => {
    const { data: dropDownData } = useNavBarData();
    const { data: homeData } = useHomeData();

    // Dati del bottone CTA dalla CMS (bannerHome)
    const ctaButtonText = homeData?.staticMedia?.bannerHome?.navbarButton;
    const ctaButtonUrl = homeData?.staticMedia?.bannerHome?.navbarButtonUrl;

    // Ordina i tagDestinations per priorità decrescente
    const sortedTagDestinations = useMemo(() => {
        if (!dropDownData?.tagDestinations) return [];
        return [...dropDownData.tagDestinations].sort(
            (a, b) => (b.priority || 1) - (a.priority || 1)
        );
    }, [dropDownData?.tagDestinations]);

    const [isBigDropdownOpen, setBigDropdownOpen] = useState(false);
    const [isSmallDropdownOpen, setSmallDropdownOpen] = useState(false);
    const refNavBar = useRef<HTMLDivElement>(null);
    const refDropDown = useRef<HTMLDivElement>(null);
    const [dropdownChoice, setDropdownChoice] = useState<DropDownItems>(
        DropDownItems.TOURS
    );

    const [width] = useWindowSizes();
    const isMoblie = width <= BREACKPOINT_TABLET && width > 0;

    const isSameDropdownItem = (selectedItem: DropDownItems) => {
        return selectedItem === dropdownChoice;
    };

    const dropdownHandler = (selectedItem: DropDownItems) => {
        if (selectedItem !== DropDownItems.HOWITWORKS) {
            setSmallDropdownOpen(false);
            setBigDropdownOpen(
                !(isSameDropdownItem(selectedItem) && isBigDropdownOpen)
            );
            setDropdownChoice(selectedItem);
        } else {
            setBigDropdownOpen(false);
            setSmallDropdownOpen(!isSmallDropdownOpen);
        }
    };

    const handleClickOutside = useCallback(() => {
        setBigDropdownOpen(false);
        setSmallDropdownOpen(false);
    }, []);

    useOnClickOutside([refNavBar, refDropDown], handleClickOutside);

    return (
        <div className={styles.menuSticky} style={{ zIndex: "10004" }}>
            {!isMoblie && (
                <div
                    className={styles.fixedBanner}
                    onClick={() => setShowModal(true)}
                >
                    <span className={styles.label}>{bannerLabel}</span>
                </div>
            )}

            {!isMoblie && (
                <NavBar
                    ref={refNavBar}
                    dropdownHandler={dropdownHandler}
                    isSmallDropdownOpen={isSmallDropdownOpen}
                    isBigDropdownOpen={isBigDropdownOpen}
                    closeBigDropdown={() => setBigDropdownOpen(false)}
                    closeSmallDropDown={() => setSmallDropdownOpen(false)}
                    setShowSearchModal={setShowSearchModal}
                    ctaButtonText={ctaButtonText}
                    ctaButtonUrl={ctaButtonUrl}
                />
            )}
            {isMoblie && (
                <NavBarM
                    bannerLabel={bannerLabel}
                    dropdownDataDestinations={sortedTagDestinations}
                    dropdownDataTours={dropDownData!.toursHome}
                    setShowModal={setShowModal}
                    setShowSearchModal={setShowSearchModal}
                    ctaButtonText={ctaButtonText}
                    ctaButtonUrl={ctaButtonUrl}
                />
            )}
            {isBigDropdownOpen && (
                <DropdownMenu
                    ref={refDropDown}
                    dropdownChoice={dropdownChoice}
                    dropdownDataDestinations={sortedTagDestinations}
                    dropdownDataTours={dropDownData!.toursHome}
                    onMouseLeave={() => {
                        if (isBigDropdownOpen) setBigDropdownOpen(false);
                    }}
                />
            )}
        </div>
    );
};

export default NavBarLayout;
